
import { BookingTabV4, ReceiptFormatV4 } from "@/domain/entities/BookingV4";
import { PropType } from "vue";
import { Options, prop, Vue } from "vue-class-component";

type BookingTabV4Value = typeof BookingTabV4[keyof typeof BookingTabV4];
type ReceiptFormatV4Value = typeof ReceiptFormatV4[keyof typeof ReceiptFormatV4];

class Props {
  activeTab = prop<string>({
    default: BookingTabV4.DOMESTIC,
    type: String as PropType<BookingTabV4Value>
  });
  receiptFormat = prop<string>({
    default: ReceiptFormatV4.A6,
    type: String as PropType<ReceiptFormatV4Value>
  });
}

@Options({
  name: "HeaderEditBookingV4"
})
class HeaderEditBookingV4 extends Vue.with(Props) {
  goBack() {
    this.$router.back();
  }

  showReceiptFormatMenu = false;

  get tabs(): { value: BookingTabV4Value ; label: string }[] {
    return [
      {
        value: BookingTabV4.DOMESTIC,
        label: this.$t("bookingV4.header.tabs.domestic") as string
      },
      {
        value: BookingTabV4.INTERNATIONAL,
        label: this.$t("bookingV4.header.tabs.international") as string
      }
    ];
  }

  get receiptFormatOptions(): { value: ReceiptFormatV4Value; label: string }[] {
    return [
      {
        value: ReceiptFormatV4.A6,
        label: this.$t("bookingV4.header.receiptFormat.a6") as string
      },
      {
        value: ReceiptFormatV4.A4,
        label: this.$t("bookingV4.header.receiptFormat.a4") as string
      },
      {
        value: ReceiptFormatV4.NONE,
        label: this.$t("bookingV4.header.receiptFormat.none") as string
      }
    ];
  }

  get activeReceiptFormatLabel(): string {
    const found = this.receiptFormatOptions.find(
      (option) => option.value === this.receiptFormat
    );
    return found
      ? found.label
      : (this.$t("bookingV4.header.receiptFormat.title") as string);
  }

  onTabClick(value: BookingTabV4Value) {
    this.$emit("update:activeTab", value);
  }

  toggleReceiptFormatMenu() {
    this.showReceiptFormatMenu = !this.showReceiptFormatMenu;
  }

  closeReceiptFormatMenu() {
    this.showReceiptFormatMenu = false;
  }

  onReceiptFormatClick(value: ReceiptFormatV4Value) {
    this.showReceiptFormatMenu = false;
    this.$emit("update:receiptFormat", value);
  }
}

export default HeaderEditBookingV4;
